import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { EnumeratedSetValue } from 'utility-js-enumeration';

export class PathTask implements IIndexable {
  id: string;
  base_ts: moment.Moment;
  start_ts: moment.Moment;
  end_ts: moment.Moment;
  status: string;
  event: number;
  item: number;
  is_completable: boolean;
  is_dismissible: boolean;
  mandatory: boolean;
  status_changed_ts?: string;
  is_overdue?: boolean;
  repeated_by: number;
  overdue_message?: string;
  substitute_text_by_field_by_item?: object;
  topic_id?: number;
  category: EnumeratedSetValue;
  calendar_synced_ts?: string;
  show: boolean;
  is_pending_complete: boolean;

  constructor(task: Partial<PathTask>) {
    task.id = `${task.event}_${task.repeated_by}`;
    task.base_ts = moment(task.base_ts as moment.Moment);
    task.start_ts = moment(task.start_ts as moment.Moment);
    task.end_ts = moment(task.end_ts as moment.Moment);

    _4.merge(this, task);
  }

  static build(task: Partial<PathTask>): PathTask {
    return new PathTask(task);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/builders/path_task_builder.ts